import React from 'react';
import { Button } from 'react-bootstrap';

import ConfigBsale from './configbsale';
import ConfigCommon from './configcommon';
import ConfigShopify from './configshopify';
import ImTokensGetter from '../services/imtokensgetter';

function ConfigForm(props) {
  const [integration, setIntegration] = React.useState(props.integration);

  const onChangeIntegration = (config_name, new_config) => {
    setIntegration({
      ...integration,
      [config_name]: { ...integration[config_name], ...new_config },
    });
  };

  const onChangeCommon = (new_config) => {
    onChangeIntegration('common', new_config);
  };

  const onChangeBsale = (new_config) => {
    onChangeIntegration('bsale', new_config);
  };

  const onChangeShopify = (new_config) => {
    onChangeIntegration('shopify', new_config);
  };

  const site_name = integration.common?.site_name;

  // Los tokens de bsale/shopify se leen en vivo desde IM, no se editan acá
  React.useEffect(() => {
    if (!site_name) return;

    let cancelled = false;

    new ImTokensGetter(props.access_token).get(site_name).then((tokens) => {
      if (cancelled || !tokens) return;

      setIntegration((current) => ({
        ...current,
        bsale: {
          ...current.bsale,
          access_token: tokens.bsale.access_token
        },
        shopify: {
          ...current.shopify,
          access_token: tokens.shopify.access_token,
          site_name: tokens.shopify.site_name
        }
      }));
    });

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site_name]);

  return (
    <>
      <ConfigCommon
        {...integration.common}
        access_token={props.access_token}
        onChange={onChangeCommon}
      />
      <hr />
      <ConfigBsale
        {...integration.bsale}
        site_name={integration.common?.site_name}
        lp_access_token={props.access_token}
        onChange={onChangeBsale}
      />
      <hr />
      <ConfigShopify {...integration.shopify} onChange={onChangeShopify} />
      <hr />

      <div className="d-grid gap-2">
        {/* Botón Crear/Actualizar: guarda la configuración */}
        <Button
          variant="primary"
          type="button"
          onClick={() => {
            if (integration.id === undefined) props.onCreate(integration);
            else props.onUpdate(integration);
          }}
          disabled={props.isProcessing}
        >
          {props.isProcessing ? 'Enviando...' : 'Crear/Actualizar'}
        </Button>

        {/* Botón Sincronizar Precios: dispara una sincronización real contra BSale */}
        <Button
          variant="warning"
          type="button"
          onClick={async () => {
            if (!integration.common?.site_name) {
              alert('No hay site_name definido');
              return;
            }

            props.setSyncingPrices(true);

            try {
              const response = await fetch(
                `${process.env.REACT_APP_API_URL}/bsale/price/sync/${integration.common.site_name}`,
                {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                }
              );

              if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText);
              }

              const data = await response.json();
              console.log('Sincronización exitosa:', data);
              alert('Precios sincronizados correctamente');
            } catch (err) {
              console.error(err);
              alert('Error al sincronizar precios: ' + err.message);
            } finally {
              props.setSyncingPrices(false);
            }
          }}
          disabled={props.isProcessing || props.syncingPrices}
        >
          {props.syncingPrices ? 'Sincronizando...' : 'Sincronizar Precios'}
        </Button>
      </div>
    </>
  );
}

export default ConfigForm;
